<template>
    <div class="payments" v-if="selectedCarrier !== null">
        <div class="row">
            <div class="col">
                <h3>{{ translations['Payment type'] }} <span class="change-payment" v-if="selectedPayment" @click="unsetPayment">{{ translations['change'] }}</span></h3>
            </div>
        </div>
        <div class="payments-list">
            <div v-for="payment in payments" :key="payment.uniqueName">
                <div class="row" v-if="isVisible(payment)">
                    <div class="col">
                        <div class="payment-line" @click="setPayment(payment.uniqueName)">
                             <div class="row">
                                 <div class="col-2 text-center">
                                     <span class="payment-selector">
                                         <span class="payment-selector-active" v-if="selectedPayment === payment.uniqueName"></span>
                                     </span>
                                 </div>
                                 <div class="col-2 col-md-1 payment-image">
                                     <img :src="payment.img" v-if="payment.img">
                                 </div>
                                 <div class="col-8 col-xl-6 payment-title">
                                     <p><strong>{{ payment.title }}</strong></p>
                                     <p class="textSmaller">{{ payment.delay }}</p>
                                 </div>
                                 <div class="col-12 col-xl-3 text-right align-self-start payment-price">
                                     <strong>{{ payment.free ? translations['Free'] : payment.formattedPrices.price }}</strong>
                                 </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                payments: state => state.payments,
                allPayments: state => state.allPayments,
                selectedPayment: state => state.selectedPayment,
                selectedCarrier: state => state.selectedCarrier,
                carriersPaymentsMap: state => state.carriersPaymentsMap,
            }),
        },
        methods: {
            unsetPayment: function () {
                this.$store.dispatch('SELECT_PAYMENT', null)
            },
            setPayment: function (uniqueName) {
                if (this.selectedPayment === uniqueName) {
                    return
                }
                this.$store.dispatch('SELECT_PAYMENT', uniqueName)
            },
            isVisible: function (payment) {
                if (this.selectedPayment && this.selectedPayment === payment.uniqueName) {
                    return true;
                }

                if (this.selectedPayment === null && payment.active === true) {
                    return true;
                }

                return false;
            }
        },
    }
</script>
<style scoped lang="scss">
    .payments {
        h3 {
            font-size: 24px;
            font-weight: 700;
            text-transform: uppercase;
        }

        .change-payment {
            font-size: 14px;
            font-weight: 500;
            color: #f2b508;
            text-transform: lowercase;
            cursor: pointer;
        }

        .payments-list {
            .payment-line {
                border: 1px solid #f2f2f2;
                padding: 10px;
                margin-bottom: 10px;
                &.has-error {
                    border: 1px solid #da2626;
                }
                .payment-selector {
                    width: 24px;
                    height: 24px;
                    border: 1px solid #afafaf;
                    border-radius: 12px;
                    display: inline-block;
                    padding: 6px;

                    .payment-selector-active {
                        background-color: #f2b508;
                        border-radius: 10px;
                        display: inline-block;
                        height: 100%;
                        width: 100%;
                        vertical-align: top;
                        &:before {
                            content: " ";
                        }
                    }
                }
                .payment-image {
                    padding: 0;
                    img {
                        width: 100%;
                    }
                }
                .payment-title {
                    font-size: 14px;
                    font-weight: 400;
                    color: #999999;
                    strong {
                        color: #1a1a1a;
                        font-weight: 500;
                    }
                }
                .payment-price {
                    font-size: 18px;
                    font-weight: 700;
                }
            }
        }
    }
</style>
